<template>
    <div>
      <ul class="nav mb-4">
          <li class="nav-item"><router-link to="/dashboard" class="mr-1 p-2 nav-link ">DASHBOARD</router-link></li>
      </ul>
      <span><strong>- DASHBOARD <i class="fas fa-chevron-right"></i> GRÁFICOS</strong></span><br><br>

      
    </div>  
</template>

<script>


export default {
  name: 'dashboard',
  components: {
  }
}
</script>


<style scoped>

a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}
a:hover {
  background-color: #fff;
  color: #2c2c2c;
}

</style>
